
import { mapState, mapGetters, mapActions } from 'vuex';
import ReviewResourceView from '@/mixins/ReviewResourceView';
import ProductOptionsSearchBar from './ProductOptionsSearchBar';

export default {
  i18nComponentKey: 'WidgetProductReviewsProductOptions.components.ProductOptions',
  components: { ProductOptionsSearchBar },
  mixins: [ReviewResourceView],
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', ['device']),
    initialProductOptionValues() {
      return Object.entries(this.resourceParams)
        .filter(([k, _v]) => k.startsWith('product_option_'))
        .reduce((a, [k, v]) => {
          return { ...a, [k.replace('product_option_', '')]: parseInt(v) };
        }, {});
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup'])
  }
};
